var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.53846C13.5 6.31404 13.4108 6.09883 13.2522 5.94014C13.0935 5.78146 12.8782 5.69231 12.6538 5.69231H10.9615L9.69231 4H6.30769L5.03846 5.69231H3.34615C3.12174 5.69231 2.90652 5.78146 2.74783 5.94014C2.58915 6.09883 2.5 6.31404 2.5 6.53846V11.6154C2.5 11.8398 2.58915 12.055 2.74783 12.2137C2.90652 12.3724 3.12174 12.4615 3.34615 12.4615H12.6538C12.8782 12.4615 13.0935 12.3724 13.2522 12.2137C13.4108 12.055 13.5 11.8398 13.5 11.6154V6.53846Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00346 10.5577C9.05492 10.5577 9.9073 9.70531 9.9073 8.65385C9.9073 7.60238 9.05492 6.75 8.00346 6.75C6.95199 6.75 6.09961 7.60238 6.09961 8.65385C6.09961 9.70531 6.95199 10.5577 8.00346 10.5577Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxCamera);
export default __webpack_public_path__ + "static/media/icon_16px_camera.e9b312c0716ffc3d732ef7baaf103e0c.svg";
export { ForwardRef as ReactComponent };